module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-helper', [_c('div', {
    attrs: {
      "slot": "form-header"
    },
    slot: "form-header"
  }, [_c('h2', [_vm._v("Logos")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-fields"
    },
    slot: "form-fields"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-3 pa-2"
  }, [_c('v-card-title', [_c('h5', {
    staticClass: "grey--text"
  }, [_vm._v(" File Upload ")])]), _vm._v(" "), _c('v-card-media', {
    staticClass: "my-3",
    attrs: {
      "height": "100px",
      "src": _vm.logoSrc,
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-flex', {
    attrs: {
      "xs-2": "",
      "offset-xs5": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey darken-3 file-btn",
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "grey--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("backup")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.mk.logos), function(logo, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', [_c('v-card-media', {
      attrs: {
        "src": _vm.markenlogo(logo.dateiserverpfad),
        "height": "60px",
        "contain": ""
      }
    }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "grey darken-3",
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.removeImage(index)
        }
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "form-commands"
    },
    slot: "form-commands"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.submitted
    }
  }, [_c('v-icon', {
    staticClass: "green--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("done")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/marken",
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298aa5b7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marken/editMarken_2.vue
// module id = 314
// module chunks = 0